import React, { Component } from "react";
import PropTypes from "prop-types";
import Icon from "module-common/Icon";
import Picker from "module-common/Picker";
import { graphql, compose } from "react-apollo";
import { CaseManagementStore, ShowNotice } from "Store";
import {
  mutationApproveEscalatedCase,
  mutationRejectEscalatedCase,
  mutationDeletePendingStream
} from "Apollo";

export default compose(
  graphql(mutationApproveEscalatedCase, { name: "approveMutate" }),
  graphql(mutationRejectEscalatedCase, { name: "rejectMutate" }),
  graphql(mutationDeletePendingStream, { name: "deleteMutate" })
)(
  class BubbleOption extends Component {
    static propTypes = {
      id: PropTypes.number,
      canEdit: PropTypes.bool,
      canDelete: PropTypes.bool,
      canApprove: PropTypes.bool,
      canDisapprove: PropTypes.bool,
      content: PropTypes.string
    };

    render() {
      const { canEdit, canDelete, canApprove, canDisapprove } = this.props;

      // build options
      const options = [];
      if (canEdit) options.push({ label: "Edit" });
      if (canDelete) options.push({ label: "Delete" });
      if (canApprove) options.push({ label: "Approve" });
      if (canDisapprove) options.push({ label: "Reject" });

      return (
        <Picker margin={0} options={options} onSelected={this.onSelected}>
          <Icon name={"arrow-down-white"} width={12} {...this.props} />
        </Picker>
      );
    }

    onSelected = selected => {
      const { id, content } = this.props;
      const store = CaseManagementStore;
      if (selected.label === "Approve") {
        try {
          this.props.approveMutate({
            variables: {
              pendingStream: { id }
            }
          });
          ShowNotice("pending-approve-success");
        } catch (error) {
          ShowNotice("pending-approve-error");
        }
      } else if (selected.label === "Reject") {
        store.rejectPending = { id: id, content: "" };
      } else if (selected.label === "Delete") {
        try {
          this.props.deleteMutate({
            variables: {
              pendingStream: { id }
            }
          });
          ShowNotice("pending-delete-success");
        } catch (error) {
          ShowNotice("pending-delete-error");
        }
      } else if (selected.label === "Edit") {
        store.editPending = { id: id, content: content };
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/approval-list/bubble/BubbleOptionWithStoreMutation.js